import storeManager from '../StoreManager';

const mediaResourcesReader = {
    getResource(identifier, mediaResources = storeManager.getState().mediaResources) {
        return mediaResources[identifier];
    },

    isSourceCached(identifier, url, mediaResources = storeManager.getState().mediaResources) {
        return this.getResource(identifier, mediaResources)?.cachedSource?.url === url;
    },

    isSourceErrored(identifier, url, crossOrigin, mediaResources = storeManager.getState().mediaResources) {
        const resource = this.getResource(identifier, mediaResources);
        const res = resource?.erroredSources?.find(source => source.url === url && source.crossOrigin === crossOrigin);
        return res;
    },

    isSourceLoaded(identifier, url, crossOrigin, mediaResources = storeManager.getState().mediaResources) {
        const resource = this.getResource(identifier, mediaResources);
        return !!(resource?.loadedSource?.url === url && resource.loadedSource?.crossOrigin === crossOrigin);
    },
};

export default mediaResourcesReader;
